import { cn } from "@/lib/utils";
import type { QuoteStatus } from "@/lib/quotes";

const STATUS_STYLE: Record<QuoteStatus, string> = {
  Draft:     "bg-slate-200 text-slate-800",
  Sent:      "bg-amber-200 text-amber-900",
  Approved:  "bg-emerald-200 text-emerald-900",
  Rejected:  "bg-rose-200 text-rose-900",
  Converted: "bg-violet-200 text-violet-900",
  Expired:   "bg-zinc-300 text-zinc-800",
};

export function QuoteStatusBadge({ status, className }: { status: QuoteStatus; className?: string }) {
  return (
    <span
      className={cn(
        "inline-block rounded px-2 py-0.5 text-xs font-medium",
        STATUS_STYLE[status],
        className,
      )}
    >
      {status}
    </span>
  );
}
